import React, { Component } from "react";
import BsySortableColumns from "../../BsySortableColumns";
import BsyDialog from "../../BsyDialog";
import BsyDashboardMyAppConfig from "../BsyDashboardMyAppConfig";
import _ from "lodash";
import { BsyUtils } from "../../../utils/Utils";
import BsyBadge from "../../BsyBadge";

export default class AppGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apps: props.apps,
      columns: [],
    };
    this.selectApp = [];
    this.dialogRef = React.createRef();
  }

  componentDidMount() {
    const { apps } = this.state;
    this.setState({
      columns: this.makeColumns(apps),
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    // console.log('UNSAFE_componentWillReceiveProps:', _.cloneDeep(nextProps.apps));
    this.setState({
      apps: nextProps.apps,
      columns: this.makeColumns(nextProps.apps),
    });
  }

  renderAppItem = (data) => {
    const { selectApp } = this;
    return (
      <div
        className={`bys-group-box-item  ${
          selectApp.includes(data._id) ? "select" : ""
        }`}
        style={{
          // marginBottom: `16px`,
          display:
            this.select &&
            data._id !== this.select?._id &&
            selectApp.includes(data._id)
              ? "none"
              : "",
        }}
        id={data._id}
        onClick={(event) => {
          const newSelectApp = selectApp.includes(data._id)
            ? selectApp.filter((item) => item !== data._id)
            : [...selectApp, data._id];
          this.selectApp = newSelectApp;
          this.props.onSetGroup(this.state.apps);
        }}
        key={"box-" + data._id}
      >
        {data._id === this.select?._id && selectApp.length ? (
          <BsyBadge className={"red"}>{selectApp.length}</BsyBadge>
        ) : (
          ""
        )}
        <div className="view">
          <div className="app-wrapper">
            <div className="icon-wrapper">
              <div className={"icon-backgroup color-cover-" + data.style.color}>
                <div
                  className={"imgbg-bsy-app imgbg-bsy-app-" + data.style.icon}
                ></div>
              </div>
            </div>
            <div
              className="app-title"
              title={data.appname}
              id={"app_title_" + data._id}
            >
              {data.appname}
            </div>
          </div>
        </div>
        <div
          className={`op`}
          style={{
            display: selectApp.length ? "block" : "",
          }}
        >
          <i className={selectApp.includes(data._id)?"icon-new-ok":"icon-new-no"} />
        </div>
      </div>
    );
  };

  handleChange = (newColumns) => {
    if (!this.select) {
      return;
    }

    const newApps = newColumns.map((item, index) => {
      return {
        ...item,
        apps: item.apps.map((data, index) => {
          return {
            ...data,
            content: undefined,
          };
        }),
      };
    });
    // 后续可以优化，_.cloneDeep 可能会存在性能问题，目前不影响
    // const batchApps = this.batchMoveItems(_.cloneDeep(newApps));
    // console.log('列表数据已更新:', _.cloneDeep(newApps));
    this.props.onSetGroup(newApps);
  };

  // 获取所有选中的元素，并把拖动的元素放到第一的位置
  getSelectItems = (apps) => {
    const firstId = this.select._id;
    let groupIndex = -1;
    let appIndex = -1;
    const selectApp = this.selectApp.filter((res) => {
      return res !== firstId;
    });

    // 过滤选择app，并生成新的结构
    let selectApps = []; //选中的app列表
    const newApps = apps.map((item, groupidx) => {
      // 先过滤掉
      if (item.apps && item.apps.length > 0) {
        item.apps = item.apps.filter((data, appidx) => {
          const isInclude = selectApp.includes(data._id);
          if (data._id === firstId) {
            groupIndex = groupidx;
            appIndex = appidx;
          }
          if (isInclude) {
            selectApps.push(data);
          }
          return !isInclude;
        });
      }
      return item;
    }); //过滤后生成的新的列表
    console.log(
      "getSelectItems",
      _.cloneDeep({
        selectApps,
        newApps,
        groupIndex,
        appIndex,
      })
    );
    return {
      selectApps,
      newApps,
      groupIndex,
      appIndex,
    };
  };

  // 处理多个选择的元素，一起移动位置
  batchMoveItems = (apps) => {
    const { selectApps, newApps, groupIndex, appIndex } =
      this.getSelectItems(apps);
    BsyUtils.insertArrayIntoArray(
      newApps[groupIndex].apps,
      appIndex + 1,
      selectApps
    );
    return _.cloneDeep(newApps);
  };

  handleStart = (item) => {
    const { apps } = this.state;
    // 按下选中拖动的元素
    this.select = item;
    this.setState({
      columns: this.makeColumns(apps),
    });
  };

  handleEnd = (item) => {
    // 按下选中拖动的元素
    const { apps } = this.state;
    // 选择多个应用的时候，才处理批量的逻辑
    if (this.selectApp.length > 1) {
      const batchApps = this.batchMoveItems(_.cloneDeep(apps));
      console.log("handleEnd:", _.cloneDeep(batchApps));
      // 清理选择状态
      this.select = null;
      this.selectApp = [];
      this.props.onSetGroup(_.cloneDeep(batchApps));
    } else {
      // 清理选择状态
      this.select = null;
      this.selectApp = [];
      this.props.onSetGroup(apps);
    }
  };

  addAppToGroup = (select, res) => {
    const { apps } = this.state;

    let ids = select.map((item, index) => {
      return item._id;
    });

    const newApps = apps
      .map((item, index) => {
        // 先过滤掉
        if (item.apps && item.apps.length > 0) {
          item.apps = item.apps.filter((data, index) => {
            return !ids.includes(data._id);
          });
        }
        return item;
      })
      .map((item, index) => {
        if (item._id === res._id) {
          return {
            ...item,
            apps: [...item.apps, ...select],
          };
        }
        return item;
      });
    this.props.onSetGroup(newApps);
  };

  onAddGroup = (res) => {
    BsyDialog({
      title: React.language("setting"),
      height: 600,
      width: 720,
      noFooter: false,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onOk: () => {
        const ret = this.dialogRef.current.getValue();
        this.addAppToGroup(ret, res);
      },
      onContentCreate: () => {
        return (
          <BsyDashboardMyAppConfig
            apps={this.state.apps}
            ref={this.dialogRef}
          />
        );
      },
    });
  };

  renderGroupDetail = () => {
    const { columns } = this.state;
    // console.log('renderGroupDetail:', _.cloneDeep(columns));
    return (
      <div className={`group-detail ${this.selectApp.length ? "select" : ""}`}>
        <div className="detail-header">
          <div className="title">{React.language("app.mine")}</div>
        </div>
        <BsySortableColumns
          columns={columns}
          titleField="name"
          keyField="_id"
          itemsField="apps"
          columnsItemClass="bys-group-box t-bys-group-box"
          onEmptyGroup={(res) => {
            return (
              <div className={` data-empty  `}>
                <span>{React.language("app.group.empty")}</span>
                <span
                  className="empty-text"
                  onClick={() => {
                    this.onAddGroup(res);
                  }}
                >
                  {React.language("setting")}
                </span>
              </div>
            );
          }}
          onStart={this.handleStart}
          onEnd={this.handleEnd}
          onChange={this.handleChange}
        />
      </div>
    );
  };

  makeColumns = (apps) => {
    // console.log('makeColumns')
    return apps.map((item, index) => {
      return {
        ...item,
        apps: item.apps.map((data, index) => {
          return {
            ...data,
            content: this.renderAppItem(data),
          };
        }),
      };
    });
  };

  render() {
    return <>{this.renderGroupDetail()}</>;
  }
}
